import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import { SelectOption } from "../../common/types"
import { setMerchantID } from "../../state/payment-processor/reducer"
import { RootState } from "../../state/store"
import { useGetPaymentAccounts } from "../usePaymentAccountSession"

const PaymentAccountSelect = () => {

    const merchantID = useSelector((state: RootState) => state.paymentProcessing.merchantID)
    const dispatch = useDispatch()
    const [paymentAccountsOptions, setPaymentAccountsOptions] = useState<Array<SelectOption<string>>>([])
    const [selectedPaymentAccount, setSelectedPaymentAccount] = useState<SelectOption<string>>()

    const {paymentAccounts} = useGetPaymentAccounts()

    useEffect(() => {
        const options = paymentAccounts?.filter(pa => pa.isActive())
            .map((pa) => {
                return {
                    value: pa.getMerchantId(),
                    label: pa.getName()
                }
            }) || []

        setPaymentAccountsOptions(options)
    }, [paymentAccounts])

    useEffect(() => {
        paymentAccounts?.forEach((pa) => {
            if (merchantID === pa.getMerchantId()) {
                const option = {
                    value: pa.getMerchantId(),
                    label: pa.getName()
                }
                setSelectedPaymentAccount(option)
            }
        })
    }, [merchantID])

    const onChange = (selectedOption: SelectOption<string>) => {
        dispatch(setMerchantID(selectedOption.value))
    }

    return (
        <Select
            value={selectedPaymentAccount}
            options={paymentAccountsOptions}
            onChange={onChange}
            clearable={false}
        />
    )

}

export default PaymentAccountSelect


// WEBPACK FOOTER //
// ./src/payment-processing/payment-listing/PaymentAccountSelect.tsx